import { Container, Stack, Box, Heading, Text, Icon } from "@chakra-ui/react";
import { useI18n } from "src/i18n/I18nContext";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LuArrowRight, LuCalendarDays } from "react-icons/lu";
import ProjectFundingVisual from "./ProjectFundingVisual";
import Carousel from "./Carousel";
import { OrgUtil } from "src/data/OrgUtil";

const cards = OrgUtil.isDemo(null)
    ? [
        '/images/org/demo/kids.webp',
        '/images/org/demo/flower.webp',
        '/images/org/demo/board.webp',
    ]
    : [
        '/images/org/cooperaid/ueberuns.webp',
        '/images/org/cooperaid/uganda-schuljungs-liegen.webp',
        '/images/org/cooperaid/kontakt.webp',
    ];

const Hero = () => {
    const { t } = useI18n();
    const navigate = useNavigate();

    return (
        <Container maxW={{ base: '2xl', sm: '3xl', md: '4xl', lg: '6xl' }}>
            <Stack
                textAlign={'center'}
                gap={{ base: 6, md: 8 }}
                py={{ base: 8, md: 16, lg: 24 }}>
                <Stack align='center' gap={{ base: 4, md: 5 }}>
                    <Text
                        color='green.600'
                        fontSize={{ base: 'sm', md: 'md' }}
                        fontWeight='bold'
                        letterSpacing='wide'
                        textTransform='uppercase'
                    >
                        {t('hero.category')}
                    </Text>
                    <Heading
                        maxW='5xl'
                        fontWeight={'bold'}
                        fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                        lineHeight={{ base: '1.1', md: '1.05' }}
                    >
                        {t('hero.title')}
                    </Heading>
                    <Text
                        maxW='3xl'
                        color='fg.muted'
                        fontSize={{ base: 'lg', md: '2xl' }}
                        lineHeight='1.6'
                    >
                        {t('hero.subtitle')}
                    </Text>
                    <Stack
                        align='center'
                        gap='3'
                        w='full'
                        maxW='lg'
                    >
                        <Text color='fg.muted' fontSize={{ base: 'sm', md: 'md' }} lineHeight='1.6'>
                            {t('hero.signupNote')}
                        </Text>
                        <Stack direction={{ base: 'column', sm: 'row' }} gap='3' w='full' h='24'>
                            <Button
                                variant='outline'
                                colorPalette='blue'
                                size='lg'
                                h='14'
                                flex='1'
                                rounded='xl'
                                px='6'
                                boxShadow='sm'
                                onClick={() => navigate('/contact?topic=demo')}
                            >
                                <Icon as={LuCalendarDays} />
                                {t('hero.primaryCta')}
                            </Button>
                            <Button
                                colorPalette='blue'
                                size='lg'
                                h='14'
                                flex='1'
                                rounded='xl'
                                px='6'
                                boxShadow='sm'
                                onClick={() => navigate('/signup')}
                            >
                                {t('landing.signupLink')}
                                <Icon as={LuArrowRight} />
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
                <Box overflow='hidden' rounded='lg' boxShadow='2xl'>
                    <Carousel cards={cards} />
                </Box>
                <Box id='how-it-works' scrollMarginTop='7rem'>
                    <ProjectFundingVisual />
                </Box>
            </Stack>
        </Container>
    );
}

export default Hero
